import { render, staticRenderFns } from "./failure.vue?vue&type=template&id=fe508e50&scoped=true"
import script from "./failure.js?vue&type=script&lang=js&external"
export * from "./failure.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe508e50",
  null
  
)

export default component.exports